import { render, staticRenderFns } from "./sendList.vue?vue&type=template&id=37531b13&scoped=true"
import script from "./sendList.vue?vue&type=script&lang=js"
export * from "./sendList.vue?vue&type=script&lang=js"
import style0 from "./sendList.vue?vue&type=style&index=0&id=37531b13&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37531b13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37531b13')) {
      api.createRecord('37531b13', component.options)
    } else {
      api.reload('37531b13', component.options)
    }
    module.hot.accept("./sendList.vue?vue&type=template&id=37531b13&scoped=true", function () {
      api.rerender('37531b13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/synthesize/superviseAndHandle/sendList.vue"
export default component.exports